<template>
  <div class="page_body">
    <h1 class="font-mont">Overview Dashboard</h1>

    <section class="d-grid dashboard_content">
      <div class="round_box">
        <div class="box_header">
          <a href="" class="d-flex flex-sb al-cnt">
            <h3>일정 및 안내</h3>
            <img src="@/assets/img/box_header_btn.svg">
          </a>
        </div>
        <div class="box_content">
          <div v-for="(schedule, idx) in schedules" :key="{idx}">
            <em>{{ schedule[0] }}</em>
            <b>{{ schedule[1] }}</b>
            <span>{{ schedule[2] }}</span>
            <span>{{ schedule[3] }}</span>
          </div>
        </div>				
      </div>
      <!-- 회의 목록 -->
      <div class="round_box">
        <div class="box_header">
          <a href="" class="d-flex flex-sb">
            <h3>회의 목록</h3>
            <img src="@/assets/img/box_header_btn.svg">
          </a>
        </div>
        <div class="box_content">
          <div v-for="(meeting, idx) in meetings" :key="{idx}">
            <em>{{ meeting[0] }}</em>
            <b>{{ meeting[1] }}</b>
            <span>{{ meeting[2] }}</span>
            <span>{{ meeting[3] }}</span>
          </div>
        </div>
      </div>
      <div class="round_box">
        <div class="box_header txt_only">
          <a href="" class="d-flex flex-sb">
            <h3>데이터수집 그래프</h3>
          </a>
        </div>
        <div class="box_content">					
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      schedules: [],
      meetings: []
    }
  },
  created () {
   // this.getData()
  },
  methods: {
    getData () {
      this.$axios.get('/')
            .then((res) => {
              this.schedules = res.data.schedules
              this.meetings = res.data.meetings
            })
            .catch((error) => {
              console.error(error)
            })
    }
  }
}
</script>
